var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27438 7.58349C8.34362 7.53742 8.42327 7.50934 8.5061 7.50181C8.58893 7.49428 8.67233 7.50753 8.74875 7.54037L11.6963 8.86099C11.7956 8.90345 11.8785 8.97693 11.9326 9.07044C11.9867 9.16396 12.009 9.27247 11.9963 9.37974C11.8991 10.1054 11.5418 10.7711 10.9907 11.253C10.4395 11.7349 9.73212 12.0003 9 11.9997C6.74566 11.9997 4.58365 11.1042 2.98959 9.51015C1.39553 7.91609 0.500001 5.75408 0.500001 3.49974C0.499441 2.76762 0.7648 2.06021 1.24673 1.50908C1.72865 0.95794 2.39435 0.600593 3.12 0.503492C3.22727 0.490748 3.33578 0.513088 3.4293 0.567168C3.52281 0.621248 3.5963 0.70416 3.63875 0.803492L4.95938 3.75349C4.99182 3.82926 5.00504 3.91187 4.99784 3.99398C4.99064 4.07609 4.96326 4.15515 4.91813 4.22412L3.5825 5.81224C3.53512 5.88373 3.50711 5.96629 3.50119 6.05185C3.49528 6.13741 3.51166 6.22304 3.54875 6.30037C4.06563 7.35849 5.15938 8.43912 6.22063 8.95099C6.29836 8.98792 6.38439 9.00394 6.47021 8.99747C6.55602 8.991 6.63867 8.96228 6.71 8.91412L8.27438 7.58349Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8d1a809de62cafae0c09a18a523d9eab.svg";
export { ForwardRef as ReactComponent };